import { setCssVar } from 'quasar'

type BrandColorName = 'primary' | 'secondary' | 'accent' | 'positive' | 'negative' | 'info' | 'warning'
type BrandColors = Record<BrandColorName, string>

export const lightBrandColors: BrandColors = {
  primary: '#0e63cb',
  secondary: '#26a69a',
  accent: '#9c27b0',
  positive: '#21ba45',
  negative: '#c10015',
  info: '#75dff5',
  warning: '#f2c037',
}

export const darkBrandColors: BrandColors = {
  primary: '#8dcaff',
  secondary: '#80cbc3',
  accent: '#ce93d8',
  positive: '#9ddda4',
  negative: '#f59999',
  info: '#85e2f7',
  warning: '#faf5a0',
}

export const setBrandColors = (brandColors: BrandColors) => {
  ;(Object.keys(brandColors) as BrandColorName[]).forEach((brandColorName) => {
    setCssVar(brandColorName, brandColors[brandColorName])
  })
}
